import axios from "axios"

const MAIN_API_HOST = process.env.REACT_APP_MAIN_API_HOST

export function ShoppingCartStageApi(props) {
    return {
        searchList: async ({ params, headers, body }) => {
            return await axios.get(`${MAIN_API_HOST}/shopping-cart-stages`, {
                params,
                headers
            })
        },
        createList: async ({ params, headers, body }) => {
            return await axios.post(`${MAIN_API_HOST}/shopping-cart-stages/create-list`, body, {
                params,
                headers
            })
        },
        updateOne: async ({ params, headers, body }) => {
            return await axios.put(`${MAIN_API_HOST}/shopping-cart-stages/update-one`, body, {
                params,
                headers
            })
        },
        deleteOne: async ({ params, headers, body }) => {
            return await axios.delete(`${MAIN_API_HOST}/shopping-cart-stages/delete-one`, {
                params,
                headers
            })
        }
    }
}